var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-4" }, [
    _c("header", { staticClass: "pb-4" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "border-bottom" },
        [
          _c(
            "v-tabs",
            {
              on: {
                change: function ($event) {
                  return _vm.CHANGE()
                },
              },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c("v-tab", { key: "global" }, [_vm._v("General")]),
              _vm._v(" "),
              _c("v-tab", { key: "fixed-price" }, [_vm._v("Precios fijos")]),
              _vm._v(" "),
              _c("v-tab", { key: "shipping" }, [_vm._v("Envío")]),
              _vm._v(" "),
              _c("v-tab", { key: "nationalization" }, [
                _vm._v("Nacionalización"),
              ]),
              _vm._v(" "),
              _c("v-tab", { key: "handling" }, [_vm._v("Manejo")]),
              _vm._v(" "),
              _c("v-tab", { key: "insurance" }, [_vm._v("Seguro")]),
              _vm._v(" "),
              _c("v-tab", { key: "storage" }, [_vm._v("Almacenamiento")]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("main", [
      _c("div", { staticClass: "container-fluid" }, [
        _c(
          "div",
          { staticClass: "vstack gap-4" },
          [
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  "v-tab-item",
                  { key: "global" },
                  [_vm.tab == 0 ? _c("global") : _vm._e()],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { key: "fixed-price" },
                  [_vm.tab == 1 ? _c("fixed-price") : _vm._e()],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { key: "shipping" },
                  [_vm.tab == 2 ? _c("shipping") : _vm._e()],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { key: "nationalization" },
                  [_vm.tab == 3 ? _c("nationalization") : _vm._e()],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { key: "handling" },
                  [_vm.tab == 4 ? _c("handling") : _vm._e()],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { key: "insurance" },
                  [_vm.tab == 5 ? _c("insurance") : _vm._e()],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { key: "storage" },
                  [_vm.tab == 6 ? _c("storage") : _vm._e()],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-end" }, [
        _c("div", { staticClass: "col-sm col-12" }, [
          _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Calculadora")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }